/*
 * Public API Surface of ngx-lib/core/common/model
 */
export * from './api.model';
export * from './utilities.model';
